import React, { useCallback, useEffect, useRef, useState } from 'react'
import { extractContent } from '../../aux2.js'
import PersistentContentEditable from '../../Components/PersistentContentEditable'
import { keyboardLanguages } from '../../StaticData/SiteData.js'
import { Button } from '@material-ui/core'
import { useSearchContext } from '../../Context/SearchContext.js'
import { useTextboxContext } from '../../Context/TextboxContext.js'

const translabel = {
    google: {
        searchin: 'UI.(button)Search Google in {Lang}'
    },
    wiki: {
        searchin: 'UI.(button)Search Wikipedia in {Lang}'
    }
}
export const SearchButton = ({ clickIt = false, i18n, kbLangKey, q, sectionKey }) => {
    const [TextboxState] = useTextboxContext()

    const handleSearchClick = useCallback(() => {
        if (q !== extractContent(TextboxState.qdiv)) {
            window.location.hash = 'q=' + extractContent(TextboxState.qdiv)
        }
    }, [TextboxState.qdiv, q])

    useEffect(() => {
        if (clickIt) {
            handleSearchClick()
        }
    }, [clickIt, handleSearchClick])

    return (
        <Button
            variant='contained'
            color='primary'
            name='sa'
            onClick={handleSearchClick}
            style={{ position: 'relative', color: 'white', background: '#0756d6' }}
        >
            {i18n.t(translabel[sectionKey].searchin, {
                Lang: i18n.t(`LANG.${keyboardLanguages.data[kbLangKey].name}`)
            })}
        </Button>
    )
}

export const Search = ({ LogoArea, kbLangKey, q, i18n, sectionKey }) => {
    const [searchState, searchDispatch] = useSearchContext()

    const qdiv = useRef(null)
    const [clickIt, setClickIt] = useState(false)

    const handleFocusTextarea = useCallback(() => {
        if (!searchState.showKeyboard) {
            searchDispatch({ type: 'show-keyboard', payload: true })
        }
    }, [searchDispatch, searchState.showKeyboard])

    useEffect(() => {
        if (q) {
            // searchForm.current.submit()
            searchDispatch({ type: 'show-keyboard', payload: false })
        }
        searchDispatch({
            type: 'show-results',
            payload: !!q
        })
        searchDispatch({
            type: 'update-state',
            qdiv: q
        })
        return () => searchDispatch({ type: 'show-keyboard', payload: true })
    }, [q, searchDispatch, sectionKey])

    const handleKeyDownTextarea = useCallback((e) => {
        if (e.keyCode === 13) {
            setClickIt(true)
        }
    }, [])

    return (
        <div className={'SearchSection'}>
            <style jsx>{`
                .SearchSection {
                    text-align: center;
                    background-color: #fafafa;
                    border-radius: 5px;
                    padding: 13px;
                    margin: 0 13px;
                }
                .SearchSection :global(.qdiv) {
                    width: 484px;
                }
                @media (max-width: 720px) {
                    .SearchSection :global(.qdiv) {
                        width: auto;
                    }
                }
            `}</style>

            <LogoArea />
            <PersistentContentEditable
                focus={q ? false : true}
                typeHereString={i18n.t('UI.Type here')}
                className={`defaultvkinput qdiv search_term search_on_enter`}
                innerRef={qdiv}
                oneliner={true}
                id={'qdiv_' + sectionKey}
                dataSaveId='qdiv'
                readOnly='readonly'
                role='textbox'
                tabIndex='0'
                onFocus={handleFocusTextarea}
                onClick={handleFocusTextarea}
                onKeyDown={handleKeyDownTextarea}
            />
            <SearchButton clickIt={clickIt} {...{ i18n, kbLangKey, q, sectionKey }} />
        </div>
    )
}
